module.exports = __webpack_public_path__ + "img/reg-f.d3623791.jpg";